
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trash-valet",
      function () {
        return require("private-next-pages/trash-valet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trash-valet"])
      });
    }
  